import PropTypes from 'prop-types';
import React from 'react';
import HotelSpecialOfferView from './HotelSpecialOfferView';
import HotelSpecialOfferForm from './HotelSpecialOfferForm';

class HotelSpecialOffer extends React.Component {
  constructor() {
    super();
    this.state = {
      isEditing: false,
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleEdit() {
    this.setState({ isEditing: true });
  }
  handleClose() {
    this.setState({ isEditing: false });
  }
  handleSubmit(values) {
    console.log('handle submit...', values);
    this.props.editHotel(this.props.hotel.id, values);
    this.handleClose();
  }
  render() {
    if (this.state.isEditing) {
      return (
        <HotelSpecialOfferForm
          {...this.props}
          onSubmit={this.handleSubmit}
          handleClose={this.handleClose}
          initialValues={{special_offer: this.props.hotel.special_offer}}
        />);
    }
    return (
      <HotelSpecialOfferView {...this.props} handleEdit={this.handleEdit} />
    );
  }
}
HotelSpecialOffer.propTypes = {
  hotel: PropTypes.object.isRequired,
  editHotel: PropTypes.func.isRequired,
};

export default HotelSpecialOffer;



// WEBPACK FOOTER //
// src/routes/hotels/components/HotelSpecialOffer.js